/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { AdmissionViewModel } from './AdmissionViewModel'; 

export function getAdmissionOptions(stayId: string, onSuccess?: (result: AdmissionViewModel) => void) {
	return queryOptions({
		queryKey: ['admission', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/intake/admissions/queries/getadmission/' + stayId;
			const resp = await axios.get<AdmissionViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}